import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=1bd60f98&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"
import style0 from "./Default.vue?vue&type=style&index=0&id=1bd60f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd60f98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VIcon,VImg,VLayout})
